// extracted by mini-css-extract-plugin
module.exports = {"button":"button--BORY-","button__spinner":"button__spinner--E1lJw"};